(() => {
  const initGallery = (root) => {
    const main = root.querySelector('[data-ahm-gallery-main]');
    const thumbs = root.querySelectorAll('[data-ahm-gallery-thumb]');
    if (!main || !thumbs.length) return;

    thumbs.forEach((thumb) => {
      thumb.addEventListener('click', () => {
        const src = thumb.dataset.mediaSrc;
        const srcset = thumb.dataset.mediaSrcset;
        const alt = thumb.dataset.mediaAlt || '';
        if (!src) return;

        main.innerHTML = '';
        const img = document.createElement('img');
        img.src = src;
        if (srcset) img.srcset = srcset;
        img.alt = alt;
        img.loading = 'lazy';
        img.sizes = '(min-width: 990px) 45vw, 100vw';
        main.appendChild(img);

        thumbs.forEach((item) => {
          item.classList.remove('is-active');
          item.setAttribute('aria-pressed', 'false');
        });
        thumb.classList.add('is-active');
        thumb.setAttribute('aria-pressed', 'true');
      });
    });
  };

  document.querySelectorAll('[data-ahm-product-gallery]').forEach(initGallery);
})();
